import { atom } from 'jotai';
import { chatV3Service } from '../../../services/chatV3Service';
import { messagesAtom, selectedConversationIdAtom, messageSendingAtom, newConverstaionMessageBufferAtom } from '../chatAtoms';
import { Message, MessageContent } from '../../../types';
import { v4 as uuidv4 } from 'uuid';
import { createStandaloneToast } from '@chakra-ui/react';


// 创建独立的 toast 实例
const { toast } = createStandaloneToast();

// 重新导出拆分模块中的内容，保持向后兼容
export { handleStreamingEventAtom as handleStreamingEventV2Atom } from './eventHandler';
export { processSSEStream } from './sseProcessor';

// 导入需要在旧事件处理器中使用的内容
// import { streamingChatStateAtom } from './streamingEventHandler';
import { processSSEStream } from './sseProcessor';

// // 旧的处理流式聊天事件的原子（保持兼容性）
// export const handleStreamingEventAtom = atom(
//   null,
//   async (get, set, event: { type: string; data: any }) => {
//     const currentStreamingState = get(streamingChatStateAtom);
//     try {
//       const eventData = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

//       // console.log('handleStreamingEventAtom:', event.type, eventData);
//       switch (event.type) {
//         case 'init': {
//           const data = eventData as InitEvent;
//           set(streamingChatStateAtom, () => ({
//             ...initialStreamingState,
//             toolCalls: {},
//             isStreaming: true,
//             currentMessageId: data.messageId,
//             currentConversationId: data.conversationId,
//           }));

//           // 重置首个token接收标志
//           set(firstTokenReceivedAtom, false);

//           console.log(`init_data:`, data)
//           const currentConvId = get(selectedConversationIdAtom);
//           if (!currentConvId) {
//             console.log('Conversation is Undefined! Updating to new conversation:', data.conversationId);
//             await set(fetchConversationsAtom)
//             set(selectedConversationIdAtom, data.conversationId)
//             console.log('Conversation Updated to:', get(selectedConversationIdAtom))
//             set(navigateAtom, { path: `/v3/chat-detail/${data.conversationId}`, replace: true })
//           }
//           else {
//             set(messagesAtom, (prev) => {
//               const conversationMessages = prev[data.conversationId]
//               const updatedMessages = conversationMessages.map(m => {
//                 // 只更新指定的两个消息，不影响其他历史消息
//                 if (m.id === data.frontendUserMessageId) {
//                   // 更新用户消息ID
//                   return {
//                     ...m,
//                     id: data.userMessageId,
//                     conversationId: data.conversationId,
//                     // 保持原有的时间戳，不覆盖
//                   };
//                 } else if (m.id === data.frontendAssistantMessageId) {
//                   // 更新助手消息ID，并设置关联关系和处理开始时间
//                   return {
//                     ...m,
//                     id: data.messageId,
//                     conversationId: data.conversationId,
//                     parentMessageId: data.userMessageId,
//                     metadata: {
//                       ...(m.metadata || {}),
//                       status: 'streaming',
//                       processingStartTime: data.timestamp, // 存储处理开始时间
//                     }
//                   };
//                 } else {
//                   // 其他历史消息保持不变
//                   return m;
//                 }
//               });

//               return { ...prev, [data.conversationId]: updatedMessages };
//             });

//             // 更新对话的更新时间（如果不存在则创建）
//             set(updateSelectedConversationAtom, {
//               updatedAt: data.timestamp
//             });
//           }



//           break;
//         }

//         case 'content_block_start': {
//           const data = eventData as ContentBlockStartEvent & { index: number, content_block: { type: string, text?: string, id?: string, name?: string, input?: any } };

//           set(streamingChatStateAtom, (prev) => ({
//             ...prev,
//             currentActiveBlockIndex: data.index,
//             currentActiveBlockType: data.content_block.type,
//             currentActiveToolIdForInput: data.content_block.type === 'tool_use' ? data.content_block.id || null : prev.currentActiveToolIdForInput,
//           }));

//           if (data.content_block.type === 'text') {
//             // Ensure message in messagesAtom is ready for text content at this block index
//             set(messagesAtom, (prevMsgs) => {
//               const conversationId = currentStreamingState.currentConversationId;
//               if (!conversationId || !currentStreamingState.currentMessageId) return prevMsgs;

//               const messages = prevMsgs[conversationId] || [];
//               const messageIndex = messages.findIndex(m => m.id === currentStreamingState.currentMessageId);
//               if (messageIndex === -1) return prevMsgs;

//               const message = messages[messageIndex];
//               let contentArray = Array.isArray(message.content) ? [...message.content] : [];

//               // Ensure a content object exists for this index, or add one.
//               // This simplistic approach assumes text blocks are somewhat contiguous or ordered by index.
//               // A more robust approach might involve managing content blocks by their specific block ID if provided by backend.
//               // For now, we ensure a text block for the current index.
//               let textBlock = contentArray[data.index] as MessageContent | undefined;
//               if (!textBlock || textBlock.type !== 'text') {
//                 contentArray[data.index] = { type: 'text', text: '' };
//               }

//               const updatedMessages = [...messages];
//               updatedMessages[messageIndex] = { ...message, content: contentArray };
//               return { ...prevMsgs, [conversationId]: updatedMessages };
//             });
//           } else if (data.content_block.type === 'tool_use' && data.content_block.id && data.content_block.name) {
//             const toolId = data.content_block.id;
//             const toolName = data.content_block.name;
//             set(messagesAtom, (prevMsgs) => {
//               const { currentConversationId, currentMessageId } = currentStreamingState;
//               if (!currentConversationId || !currentMessageId) return prevMsgs;
//               const messages = prevMsgs[currentConversationId] || [];
//               const messageIndex = messages.findIndex(m => m.id === currentMessageId);
//               if (messageIndex === -1) return prevMsgs;

//               const message = messages[messageIndex];
//               const processLog = [...(message.metadata?.processLog || [])];
//               // Avoid duplicate tool_call entries if events are re-processed or backend sends redundant block_starts
//               if (!processLog.some(p => p.type === 'tool_call' && p.toolId === toolId)) {
//                 processLog.push({
//                   type: 'tool_call',
//                   toolId: toolId,
//                   toolName: toolName,
//                   toolInput_streaming: '',
//                   status: 'pending_input',
//                   timestamp: data.timestamp || new Date().toISOString(),
//                   contentUpdateTime: new Date().toISOString()
//                 });
//                 const updatedMessages = [...messages];
//                 updatedMessages[messageIndex] = {
//                   ...message,
//                   metadata: { ...(message.metadata || {}), processLog }
//                 };
//                 return { ...prevMsgs, [currentConversationId]: updatedMessages };
//               }
//               return prevMsgs;
//             });
//           }
//           break;
//         }

//         // 注释掉旧的content_block_delta处理，因为后端发送的是text_delta
//         // case 'content_block_delta': {
//         //   // 这个事件已经被新的handleStreamingEventV2Atom处理
//         //   console.log('旧的content_block_delta处理器已废弃，请使用新的text_delta处理');
//         //   break;
//         // }

//         // case 'content_block_stop': {

//         //   const data = eventData as { index: number, timestamp?: string };
//         //   if (data.index === currentStreamingState.currentActiveBlockIndex) {
//         //     const { currentConversationId, currentMessageId, currentActiveToolIdForInput, currentActiveBlockType } = currentStreamingState;

//         //     if (currentActiveBlockType === 'tool_use' && currentActiveToolIdForInput && currentConversationId && currentMessageId) {
//         //       set(messagesAtom, (prev) => {
//         //         const messages = prev[currentConversationId] || [];
//         //         const messageIndex = messages.findIndex(m => m.id === currentMessageId);
//         //         if (messageIndex === -1) return prev;
//         //         const message = messages[messageIndex];
//         //         let processLog = [...(message.metadata?.processLog || [])];
//         //         const toolCallEntry = processLog.find(p => p.type === 'tool_call' && p.toolId === currentActiveToolIdForInput) as ProcessStep & { type: 'tool_call' } | undefined;
//         //         if (toolCallEntry && typeof toolCallEntry.toolInput_streaming === 'string') {
//         //           try {
//         //             toolCallEntry.toolInput = JSON.parse(toolCallEntry.toolInput_streaming);
//         //             toolCallEntry.status = 'pending_execution';
//         //           } catch (e) {
//         //             console.error("Failed to parse tool_input_streaming JSON:", e);
//         //             toolCallEntry.toolInput = { error: "Failed to parse input JSON", raw: toolCallEntry.toolInput_streaming };
//         //             toolCallEntry.status = 'error';
//         //           }
//         //           // delete toolCallEntry.toolInput_streaming; // Optional: clear after parsing
//         //         }
//         //         const updatedMessages = [...messages];
//         //         updatedMessages[messageIndex] = { ...message, metadata: { ...(message.metadata || {}), processLog } };
//         //         return { ...prev, [currentConversationId]: updatedMessages };
//         //       });
//         //     }
//         //     // Clean up 'latest_intermediate' timestamp from processLog for intermediate_text
//         //     set(messagesAtom, (prev) => {
//         //       if (!currentConversationId || !currentMessageId) return prev;
//         //       const messages = prev[currentConversationId] || [];
//         //       const messageIndex = messages.findIndex(m => m.id === currentMessageId);
//         //       if (messageIndex === -1) return prev;
//         //       const message = messages[messageIndex];
//         //       let processLog = (message.metadata?.processLog || []).map((p: ProcessStep) => {
//         //         if (p.type === 'intermediate_text' && p.timestamp === 'latest_intermediate') {
//         //           return { ...p, timestamp: new Date().toISOString(), contentUpdateTime: new Date().toISOString() }; // Finalize timestamp
//         //         }
//         //         return p;
//         //       });
//         //       const updatedMessages = [...messages];
//         //       updatedMessages[messageIndex] = { ...message, metadata: { ...(message.metadata || {}), processLog } };
//         //       return { ...prev, [currentConversationId]: updatedMessages };
//         //     });

//         //     set(streamingChatStateAtom, (prev) => ({ // Reset active block info
//         //       ...prev,
//         //       currentActiveBlockIndex: null,
//         //       currentActiveBlockType: null,
//         //       currentActiveToolIdForInput: null,
//         //     }));
//         //   }
//         //   break;
//         // }

//         case 'tool_result': {
//           const data = eventData as ToolResultEvent & { toolName?: string, messageId?: string };
//           const { currentConversationId, currentMessageId } = get(streamingChatStateAtom); // Get latest state

//           if (data.toolId && currentConversationId && currentMessageId && data.messageId === currentMessageId) {
//             set(messagesAtom, (prev) => {
//               const messages = prev[currentConversationId] || [];
//               const messageIndex = messages.findIndex(m => m.id === currentMessageId);
//               if (messageIndex === -1) return prev;
//               const message = messages[messageIndex];
//               let processLog = [...(message.metadata?.processLog || [])];
//               const toolCallEntry = processLog.find(p => p.type === 'tool_call' && p.toolId === data.toolId) as ProcessStep & { type: 'tool_call' } | undefined;
//               if (toolCallEntry) {
//                 toolCallEntry.result = data.result;
//                 toolCallEntry.status = 'completed';
//               }
//               const updatedMessages = [...messages];
//               updatedMessages[messageIndex] = { ...message, metadata: { ...(message.metadata || {}), processLog } };
//               return { ...prev, [currentConversationId]: updatedMessages };
//             });
//           }
//           break;
//         }

//         case 'message_stop': {
//           const data = eventData as MessageStopEvent;
//           const { currentConversationId, currentMessageId: streamingMsgId } = get(streamingChatStateAtom);

//           if (data.messageId === streamingMsgId && currentConversationId) {
//             set(messagesAtom, (prev) => {
//               const messages = prev[currentConversationId] || [];
//               const messageIndex = messages.findIndex(m => m.id === streamingMsgId);
//               if (messageIndex === -1) return prev;
//               const message = messages[messageIndex];
//               // Note: status might be 'completed' by backend, but we ensure our final interpretation.
//               // The key is NOT to reset streamingChatStateAtom here.
//               const updatedMessage = { ...message, metadata: { ...message.metadata, status: 'completed', isFinal: true } };
//               const updatedMessages = [...messages];
//               updatedMessages[messageIndex] = updatedMessage;
//               return { ...prev, [currentConversationId]: updatedMessages };
//             });
//             setTimeout(() => {
//               set(messageExpandedStateAtom, (prevExpanded) => ({ ...prevExpanded, [streamingMsgId]: false }));
//             }, 1000);
//           }
//           // DO NOT reset streamingChatStateAtom or messageSendingAtom here.
//           break;
//         }

//         case 'conversation_title_generated': {
//           const data = eventData as ConversationTitleGeneratedEvent;
//           console.log('conversation_title_generated已触发:', data);

//           // 更新对话标题
//           set(updateConversationAtom, {
//             conversationId: data.conversationId,
//             updates: {
//               title: data.title,
//               updatedAt: data.timestamp
//             }
//           });
//           break;
//         }

//         case 'intent_processing_complete': {
//           console.log('intent_processing_complete已触发:', event.type, event.data);

//           const data = eventData as { messageId: string, timestamp: string };
//           const { currentConversationId, currentMessageId: streamingMsgId } = get(streamingChatStateAtom);
//           if (data.messageId === streamingMsgId) {
//             let completedMessage: Message | null = null;

//             if (currentConversationId) {
//               // 先获取消息，然后更新状态
//               const currentMessages = get(messagesAtom)[currentConversationId] || [];
//               const messageIndex = currentMessages.findIndex(m => m.id === streamingMsgId);

//               if (messageIndex !== -1) {
//                 const message = currentMessages[messageIndex];
//                 if (message.metadata?.status !== 'completed' || message.metadata?.isFinal !== true) {
//                   const updatedMessage = {
//                     ...message,
//                     metadata: { ...message.metadata, status: 'completed', isFinal: true }
//                   };
//                   completedMessage = updatedMessage;

//                   set(messagesAtom, (prev) => {
//                     const updatedMessages = [...currentMessages];
//                     updatedMessages[messageIndex] = updatedMessage;
//                     return { ...prev, [currentConversationId]: updatedMessages };
//                   });
//                 } else {
//                   completedMessage = message;
//                 }
//               }
//             }

//             // 检查是否需要触发 TTS
//             const autoTTSEnabled = get(autoTTSEnabledAtom);
//             const voiceMode = get(voiceModeAtom);

//             if (autoTTSEnabled && voiceMode && completedMessage) {
//               console.log('TTS: 触发自动朗读，消息ID:', completedMessage.id);

//               // 异步触发 TTS，不阻塞流式处理完成
//               setTimeout(() => {
//                 try {
//                   // 动态导入 useTTS hook 的逻辑
//                   import('../../hooks/v3/chat/useTTS').then(() => {
//                     // 注意：这里不能直接使用 hook，需要手动实现 TTS 逻辑
//                     // 提取文本内容
//                     const extractTextFromContent = (content: any[]): string => {
//                       if (!Array.isArray(content)) return '';
//                       return content
//                         .filter(item => item.type === 'text')
//                         .map(item => item.text || '')
//                         .join(' ')
//                         .trim();
//                     };

//                     const text = extractTextFromContent(completedMessage!.content as any[]);
//                     if (text) {
//                       console.log('TTS: 开始合成语音，文本长度:', text.length);
//                       // 这里需要直接调用 TTS API，因为在 atom 中不能使用 hook
//                       // 实际的 TTS 调用将在组件中处理
//                       window.dispatchEvent(new CustomEvent('triggerTTS', {
//                         detail: { text, messageId: completedMessage!.id }
//                       }));
//                     }
//                   });
//                 } catch (error) {
//                   console.error('TTS: 触发自动朗读失败:', error);
//                 }
//               }, 100);
//             }

//             set(streamingChatStateAtom, initialStreamingState);
//             set(messageSendingAtom, false);
//             console.log('Intent processing complete, full stream state reset.', data.timestamp);
//           } else {
//             console.warn('intent_processing_complete for mismatched/non-active messageId:', data, streamingMsgId);
//           }
//           break;
//         }

//         default:
//           console.debug('未处理的V3事件类型:', event.type, eventData);
//       }
//     } catch (error) {
//       console.error('处理V3流式事件出错:', error);
//       // Consider setting an error state on the message or a global error atom
//       const { currentMessageId, currentConversationId } = get(streamingChatStateAtom);
//       if (currentMessageId && currentConversationId) {
//         set(messagesAtom, (prev) => {
//           const messages = prev[currentConversationId] || [];
//           const msgIdx = messages.findIndex(m => m.id === currentMessageId);
//           if (msgIdx !== -1) {
//             const updatedMessages = [...messages];
//             updatedMessages[msgIdx] = {
//               ...updatedMessages[msgIdx],
//               metadata: {
//                 ...(updatedMessages[msgIdx].metadata || {}),
//                 status: 'error',
//                 processLog: [...(updatedMessages[msgIdx].metadata?.processLog || []), { type: 'intermediate_text', text: `Error processing stream: ${error instanceof Error ? error.message : String(error)}`, timestamp: new Date().toISOString() }],
//               }
//             };
//             return { ...prev, [currentConversationId]: updatedMessages };
//           }
//           return prev;
//         });
//       }
//       set(streamingChatStateAtom, initialStreamingState); // Reset on error
//     } finally {
//       set(messageSendingAtom, false);
//     }
//   }
// );

// 消息展开/折叠状态原子
export const messageExpandedStateAtom = atom<Record<string, boolean>>({});

// 发送流式消息的原子
export const sendStreamingMessageAtom = atom(
  null,
  async (get, set, payload: { content: MessageContent[]; characterId?: string }): Promise<string | undefined> => {
    const { content, characterId } = payload;

    const conversationId = get(selectedConversationIdAtom);

    // 设置发送状态
    set(messageSendingAtom, true);
    try {
      // 创建临时用户消息
      const userMessageId = uuidv4();
      const userMessage: Message = {
        id: userMessageId,
        conversationId: conversationId,
        role: 'user',
        content: content,
        timestamp: new Date().toISOString(),
        contentUpdateTime: new Date().toISOString(),
        status: 'completed',
        metadata: {
          streaming: true
        }
      };

      // 创建临时助手消息
      const assistantMessageId = uuidv4();
      const assistantMessage: Message = {
        id: assistantMessageId,
        conversationId: conversationId,
        role: 'assistant',
        parentMessageId: userMessageId,
        content: [], // Start with empty content array
        timestamp: new Date().toISOString(),
        contentUpdateTime: new Date().toISOString(),
        processStep: [], // 将processLog提升为顶级字段
        status: 'streaming',
        metadata: {
          streaming: true
        }
      };

      // 添加用户消息和临时助手消息
      if (conversationId) {
        set(messagesAtom, (prev) => {
          const messages = prev[conversationId] || [];
          return {
            ...prev,
            [conversationId]: [...messages, userMessage, assistantMessage]
          };
        });
      } else {
        // 如果是新对话，先创建临时消息
        set(newConverstaionMessageBufferAtom, (prev) => ([
          ...prev, userMessage, assistantMessage
        ]));
      }

      // 发送流式请求
      const response = await chatV3Service.sendStreamingMessage(
        content,
        conversationId,
        characterId,
        userMessageId,
        assistantMessageId
      );

      // 处理SSE流 - 使用抽取的函数
      await processSSEStream(response, get, set, conversationId);

      // 返回对话ID
      return get(selectedConversationIdAtom);
    } catch (error) {
      console.error('发送流式消息失败:', error);
      // 显示错误提示
      toast({
        title: '发送失败',
        description: error instanceof Error ? error.message : '未知错误',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });

      return;
    } finally {
      set(messageSendingAtom, false);
    }
  }
);
